"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FORM : FIELD : RADIO : STYLES --------------- ++++++++++ */


var _default = {
  radio: {
    // background: `#FAFBFC`,
    // borderRadius: pxToEm(4),
    // border: replacePXinStringWithEM(`2px solid #EEF2F6`),
    // transform: 'scale(1.2)',
    marginRight: (0, _index.pxToEm)(17),
    marginLeft: (0, _index.pxToEm)(11) // needed because of scale which pushes outside bounding box of parent
    // height: pxToEm(24),
    // width: pxToEm(24)

  }
};
exports.default = _default;